import React from 'react';
import { ExternalLink, Play } from 'lucide-react';
import { PresentationHeader } from './PresentationHeader';
import { PresentationPhotoGrid } from './PresentationPhotoGrid';

const getYouTubeEmbedUrl = (videoId, startTime = 0) =>
  `https://www.youtube.com/embed/${videoId}?start=${startTime}`;

export const BarlettaPresentation = ({ data, photos }) => (
  <div className="space-y-6">
    <div className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden">
      <PresentationHeader title={data.title} date={data.date} location={data.location} />
      <div className="aspect-video">
        <iframe
          width="100%"
          height="100%"
          src={getYouTubeEmbedUrl(data.videoId, 5267)}
          title="Presentazione Sala Rossa Castello Svevo Barletta"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        ></iframe>
      </div>
      <div className="p-4 bg-secondary-olive">
        <a
          href={data.video}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 text-brand-primary hover:underline"
        >
          <Play className="w-4 h-4" />
          <span>Guarda su YouTube</span>
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>

    <div className="bg-bg-page rounded-lg border-2 border-brand-primary overflow-hidden">
      <div className="p-6 border-b border-border-medium">
        <h3 className="heading-5 text-brand-primary">Galleria Fotografica</h3>
      </div>
      <PresentationPhotoGrid
        photos={photos}
        altPrefix="Presentazione Barletta"
        imgHeightClass="h-48"
      />
    </div>
  </div>
);
